
	import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
	import WebRenderer from '@/components/Fitstation3DScan/WebRenderer';
	import { Observer } from 'mobx-vue';
	import { reaction } from 'mobx';
	import ThreeDFootSetup from '@/components/Fitstation3DScan/ThreeDFootSetup';
	import FootBottomSetup from '@/components/Fitstation3DScan/FootBottomSetup';
	import ThreeDFeetSetup from '@/components/Fitstation3DScan/ThreeDFeetSetup';

	@Observer
	@Component({
		components: {}
	})
	export default class Fitstation3DScan extends Vue {
		@Prop() type!: string;
		// @Prop() destroy!: boolean;
		private r?: WebRenderer;
		private _canvasContainer?: HTMLElement;
		private scanNotFound = false;
		private dispatch;

		// @Watch('destroy')
		// onDestroyChanged(destroy: boolean) {
		// 	if (destroy) {
		// 		// this.dispose();
		// 	}
		// }

		canvasReadyHandler() {
			window.dispatchEvent(new CustomEvent(this.type + 'Loaded'));
			this.$emit('canvasReady');
		}

		public async mounted() {
			this.r = new WebRenderer();
			this._canvasContainer = this.$refs.canvasContainer as HTMLElement;
			console.log('container canvas', this._canvasContainer);
			this.r.OnLoadingEnd = () => {
				this.canvasReadyHandler();
			};
			await this.tryToRender(); // if scans exists...
		}

		// private async activated() {
		// 	if (this.type === 'rightscan') {
		// 		this.dispatch = reaction(
		// 			() => this.$state.biometric.rightScanExists,
		// 			(val) => {
		// 				if (val) {
		// 					this.tryToRender();
		// 				}
		// 			}
		// 		);
		// 	}
		//
		// 	if (this.type === 'leftscan') {
		// 		this.dispatch = reaction(
		// 			() => this.$state.biometric.leftScanExists,
		// 			(val) => {
		// 				if (val) {
		// 					this.tryToRender();
		// 				}
		// 			}
		// 		);
		// 	}
		// }

		// private deactivated() {
		// 	if (this.dispatch) {
		// 		this.dispatch();
		// 	}
		// }

		public createObjURL(obj: any) {
			const blob = new Blob([obj], { type: 'application/object' });
			const url = URL.createObjectURL(blob);
			return url;
		}

		public dispose() {
			if (!this.r || !this.r.controls) {
				return;
			}
			this.r.dispose();
		}

		beforeDestroy() {
			if (!this.r || !this.r.controls) {
				return;
			}
			this.r.dispose();
		}

		activated() {
			if (!this._canvasContainer) {
				return;
			}
			this.r?.FitToElement(this._canvasContainer);
		}

		async tryToRender() {
			if (!this._canvasContainer) {
				throw new Error('NO CANVAS CONTAINER');
			}

			if (!this.r) {
				throw new Error('NO RENDERER');
			}

			const scans = await this.$state.biometric.getLatestScans();
			const isObj = ['obj', 'OBJ'].includes(scans.left?.surfaceModel?.encoding) || ['obj', 'OBJ'].includes(scans.right?.surfaceModel?.encoding);

			const leftURL = scans.left.blobURL;
			const rightURL = scans.right.blobURL;

			if (this.type === 'both') {
				if (leftURL && rightURL) {
					this.r.setup = new ThreeDFeetSetup(this.r);
					this.r?.setup.render([leftURL, rightURL], isObj, this._canvasContainer, {
						...scans.left.properties,
						...scans.right.properties
					});
					return;
				} else if (rightURL) {
					this.r.setup = new ThreeDFootSetup(this.r);
					this.r?.setup.render([rightURL], isObj, this._canvasContainer, {
						...scans.right.properties
					});
					return;
				} else if (leftURL) {
					this.r.setup = new ThreeDFootSetup(this.r);
					this.r?.setup.render([leftURL], isObj, this._canvasContainer, {
						...scans.left.properties
					});
					return;
				}

				this.scanNotFound = true;
				this.$emit('scanNotFound');
				return;
			}

			const scanURL = this.type === 'rightscan' ? scans.right.blobURL : scans.left.blobURL;
			const scanDetails = this.type === 'rightscan' ? scans.right.properties : scans.left.properties;
			if (!scanURL) {
				this.scanNotFound = true;
				this.$emit('scanNotFound');
				return;
			}
			this.r.setup = new FootBottomSetup(this.r);
			this.r?.setup.render([scanURL], isObj, this._canvasContainer, scanDetails);
		}
	}
